import { eventTypes } from "../constants/eventTypes";

export const eventValidationSchema = {
  event_name: {
    required: true,
    minLength: 3,
    maxLength: 100,
  },
  event_link: {
    required: true,
    pattern: /^(https?:\/\/.+|[^\/]+\..+)/i,
    validator: (value: string) => {
      const trimmed = value.trim();
      // Basic check that it contains a domain-like structure
      return /^(https?:\/\/)?[^\/]+\.[^\/]+/.test(trimmed);
    }
  },
  event_description: {
    required: true,
    maxLength: 200,
  },
  date: {
    required: true,
    pattern: /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/,
    validator: (value: string) => {
      if (!value) return false;
      
      // Check if format is valid
      if (!/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/.test(value)) {
        return false;
      }

      // Parse the date
      const [day, month, year] = value.split('/').map(Number);
      const inputDate = new Date(year, month - 1, day);
      
      // Check if date is valid (e.g., not 31/02/2024)
      if (inputDate.getDate() !== day || inputDate.getMonth() !== month - 1 || inputDate.getFullYear() !== year) {
        return false;
      }

      // Check if date is in the future
      return inputDate >= new Date();
    },
  },
  start_time: {
    required: true,
  },
  end_time: {
    required: true,
  },
  venue: {
    required: true,
    minLength: 4,
  },
  address: {
    required: true,
    minLength: 5,
  },
  event_types: {
    required: true,
    validator: (value: string[]) => {
      if (!Array.isArray(value) || value.length === 0) return false;
      return value.every(type => eventTypes.some(et => et.type === type));
    },
    message: "Please select at least one event type"
  },
  provider_name: {
    required: true,
  },
  event_country: { required: false }, // todo make this required if provider_country is provided
  event_region: { required: false }, // todo make this required if provider_region is provided
  // Starts with a letter or number.
  // Allows alphanumeric characters, dashes, and spaces.
  // Enforces a length of 3–10 characters.
  // Note - all events must have a postcode, we don't duplicate this from provider_postcode 
  // (not used in events) but we make it easy to input by adding as default option
  event_postcode: { 
    required: true,
    pattern: /^[A-Za-z0-9][A-Za-z0-9\- ]{2,9}$/,
    validator: (value: string) => {
      const cleanValue = value.trim();
      return /^[A-Za-z0-9][A-Za-z0-9\- ]{2,9}$/.test(cleanValue);
    }
  },
}; 


